// Components
import HistoryTime from 'components/HistoryTime';
// Utils
import { getText } from 'i18n/intl';
import _ from 'lodash';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
// Types
import type { IProps } from './sections.interface';
// Styles
import './GeneralInfo.scss';

const TimeRuleType = {
  STANDARD: 'Standard',
  TIME_SLOT: 'Time Slot',
};

const typeOptions = Object.entries(TimeRuleType).map(([value, label]) => ({
  value,
  label,
}));

const GeneralInfo = ({ timeRule, onChange, userIsSuper }: IProps) => {
  return (
    <TEDrawerSection label="General info">
      <div className="time-rule-general-info">
        {timeRule.id > 0 ? (
          <TEInput.PureText
            label="Type"
            tooltip="Type"
            value={
              timeRule.timeSlotSelection
                ? TimeRuleType.TIME_SLOT
                : TimeRuleType.STANDARD
            }
          />
        ) : (
          <TEInput.Select
            label="Type"
            tooltip="Type"
            value={timeRule.timeSlotSelection ? 'TIME_SLOT' : 'STANDARD'}
            onChange={(value) =>
              onChange({
                key: 'timeSlotSelection',
                value: value === 'TIME_SLOT' ? [] : undefined,
              })
            }
            options={typeOptions}
            data-testid="rule-type"
          />
        )}
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={timeRule.name}
          onChange={(value) => onChange({ key: 'name', value })}
          placeholder={getText('new_time_rule')}
          data-testid="rule-name"
          disabled={!userIsSuper}
        />
        <TEInput.TextArea
          label="Description"
          tooltip="Description"
          value={timeRule.description}
          onChange={(value) => onChange({ key: 'description', value })}
          data-testid="description"
          disabled={!userIsSuper}
        />
        <TEInput.PureText label="Id" tooltip="Id" value={String(timeRule.id)} />
        <HistoryTime history={timeRule?.history} />
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;
